export const LOAD = 'ethstats/avgNetworkHashrate/LOAD';
export const LOAD_SUCCESS = 'ethstats/avgNetworkHashrate/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/avgNetworkHashrate/LOAD_FAIL';
